import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const COMOCREATEACCOUNTMODAL_LEGACY_FIELD_ORDER = [
  "legal_checkbox_label"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  comoCreateAccountModalDescriptor: _generatedComoCreateAccountModalDescriptor,
  comoCreateAccountModalModalDefinition,
  comoCreateAccountModalDashboardLayout,
  comoCreateAccountModalConfig,
  comoCreateAccountModalResolveConfig,
  comoCreateAccountModalProperties,
} = doodModalConfig(
  {
    name: "Como - Create account modal",
    handle: "como-create-account-modal",
    internal_name: "ComoCreateAccountModal",
    componentType: 'ComoCreateAccountModalComponent',
    category: 'modal',
    description: "Como - Create account modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "como-create-account-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    legal_checkbox_label: propertyValue({
      type: 'wysiwyg',
      value: '',
      options: {
        "label": "Legal checkbox label",
        "help": "Legal text displayed next to the consent checkbox"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["legal_checkbox_label"],
          },
        ],
      },
    ],
  })
);

export function comoCreateAccountModalDescriptor(): IBlockDescriptor;
export function comoCreateAccountModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function comoCreateAccountModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedComoCreateAccountModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedComoCreateAccountModalDescriptor, comoCreateAccountModalProperties, fieldOrder);
}

export {
  comoCreateAccountModalModalDefinition,
  comoCreateAccountModalDashboardLayout,
  comoCreateAccountModalProperties,
  comoCreateAccountModalConfig,
  comoCreateAccountModalResolveConfig,
};

export type ComoCreateAccountModalConfig = typeof comoCreateAccountModalConfig;
